module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "check-step"
  }, [_c('ul', _vm._l((_vm.attrGroups), function(group, index) {
    return _c('li', {
      class: {
        'curStep': _vm.curStep >= index
      },
      staticStyle: {
        "list-style-type": "none"
      }
    }, [_vm._v("\n            " + _vm._s(index + 1) + "." + _vm._s(group.groupLabel) + "\n          ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "content data-block",
    staticStyle: {
      "top": "3.5rem",
      "height": "28.5rem"
    }
  }, [(_vm.error) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "#FF0000"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list-block",
    class: {
      'bottom': _vm.curStep === 0 || _vm.curStep === 1
    }
  }, [_c('ul', _vm._l((_vm.curAttrsInGroup), function(attribute, index) {
    return (attribute.customizable === 1 && attribute.isNA === false && attribute.value !== -1) ? _c('li', {
      staticClass: "item-content",
      class: _vm.getCss(attribute)
    }, [_c(_vm.getEditor(attribute), {
      tag: "editor",
      attrs: {
        "attribute": attribute,
        "attrGroups": _vm.attrGroups,
        "index": index,
        "curAttrsInGroup": _vm.curAttrsInGroup,
        "customAttrs": _vm.merchandise._customizableAttributes
      },
      on: {
        "controlForm": _vm.controlForm
      }
    })], 1) : _vm._e()
  }), 0)]), _vm._v(" "), (_vm.curStep === _vm.steps - 1) ? _c('div', {
    staticClass: "content-block top",
    class: {
      'bottom': _vm.curStep === _vm.steps - 1
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(this.$route.query.cust) ? _c('div', {
    staticClass: "col-100"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "0.7rem"
    }
  }, [_vm._v("请点击加入购物车按钮完成定制")]), _vm._v(" "), _c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.modifyProduct
    }
  }, [_vm._v("完成修改")])]) : (_vm.QuoteStatus === false) ? _c('div', {
    staticClass: "col-100"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "0.7rem"
    }
  }, [_vm._v("请点击加入购物车按钮完成定制")]), _vm._v(" "), _c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.calculatePrice
    }
  }, [_vm._v("加入购物车")])]) : _c('div', {
    staticClass: "col-100"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "0.7rem"
    }
  }, [_vm._v("此报价不可再添加商品")]), _vm._v(" "), _c('a', {
    staticClass: "button button-big button-fill button-success gotopay_button_style",
    staticStyle: {
      "background-color": "gray"
    },
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("加入购物车")])])])]) : _vm._e()]), _vm._v(" "), _c('footer', {
    staticClass: "bar bar-footer-secondary",
    staticStyle: {
      "height": "3.5rem",
      "margin": "auto",
      "position": "fixed"
    }
  }, [_c('div', {
    staticClass: "content-block buttons-row",
    staticStyle: {
      "position": "relative",
      "bottom": "1.25rem"
    }
  }, [_c('button', {
    staticClass: "button button button-round",
    on: {
      "click": _vm.pageUp
    }
  }, [_vm._v("上一步")]), _vm._v(" "), (_vm.curStep !== _vm.steps - 1) ? _c('button', {
    staticClass: "button button button-round",
    on: {
      "click": _vm.pageDown
    }
  }, [_vm._v("下一步")]) : _c('button', {
    staticClass: "button button button-round",
    staticStyle: {
      "color": "rgb(142, 142, 147)"
    }
  }, [_vm._v("下一步")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08323ab6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/Cust/CustOrder.vue
// module id = 1528
// module chunks = 8